// extracted by mini-css-extract-plugin
export default {"box":"I3Q9aXW2yUx38P47dkt5","typography":"R9RcXLwJtJzlegZGsq3m"};